module.exports = __webpack_public_path__ + "images/emoji/construction_worker.93032ecead10ac1b5fb9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/construction_worker.png
// module id = XEVK
// module chunks = 2